<template>
  <div class="rowItem">
    <CapacityModal
      :value="data.capacity"
      :is-show="isShowCapacity"
      :separate="data.separate"
      :thrusters="data.thrusters"
      @input="updateCapacity"
      @close="isShowCapacity = false"
    />
    <RowHead
      class="rowItem-head"
      :number="number"
      :capacity="data.capacity"
      @copy="$emit('copy', $event)"
      @remove="$emit('remove')"
      @capacity="showCapacity"
    />
    <div class="rowItem-main">
      <RowForm
        v-if="isEdit"
        class="rowItem-detail"
        :data="editData"
        :is-new="!firstSection"
        @submit="setData"
      />
      <RowSideForm
        v-if="isEditSide"
        class="rowItem-detail"
        :data="sideData"
        @submit="setSide"
      />
      <RowDetail
        v-if="!isEdit && !isEditSide"
        class="rowItem-detail"
        :data="data"
        :price="price"
        :row-width="rowWidth"
        :sections="data.sections"
        @edit="isEdit = true"
        @edit-side="isEditSide = true"
      />
      <div
        v-if="data.sections.length"
        class="rowItem-body"
      >
        <RowSections
          class="rowItem-sections"
          v-bind="data"
          :row-accessories="rowAccessories"
          :row-width="rowWidth"
          @edit="isEdit = true"
        />
        <RowNewSection
          class="rowItem-add"
          :data="editData"
          @submit="addSection"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import logic from '../logic';
  import CapacityModal from './CapacityModal.vue'
  import RowDetail from './RowDetail.vue'
  import RowForm from './RowForm.vue'
  import RowSideForm from './RowSideForm.vue'
  import RowHead from './RowHead.vue'
  import RowSections from './RowSections.vue'
  import RowNewSection from './RowNewSection.vue'

  export default {
    provide() {
      return {
        getRowAvailable: () => this.rowAvailable,
      };
    },
    components: {
      CapacityModal,
      RowDetail,
      RowForm,
      RowSideForm,
      RowHead,
      RowSections,
      RowNewSection,
    },
    props: {
      number: Number,
      data: Object,
      price: [Number, String],
    },
    data() {
      return {
        isEdit: true,
        isEditSide: false,
        isShowCapacity: false,
      };
    },
    computed: {
      firstSection() {
        return this.data.sections[0];
      },
      rowAvailable() {
        return logic.getRowAvailable(this.data);
      },
      editData() {
        return {
          separate: this.data.separate,
          height: this.data.height,
          depth: this.data.depth,
          thrusters: this.data.thrusters,
          width: this.firstSection ? this.firstSection.width : 1000,
          count: this.firstSection ? this.firstSection.count : 3,
        };
      },
      sideData() {
        return {
          depth: this.data.depth,
          side_wall: this.data.side_wall,
          side_wall_count: this.data.side_wall_count,
          side_wall_left: this.data.side_wall_left,
          side_wall_right: this.data.side_wall_right,
        };
      },
      rowWidth() {
        return this.data.sections.reduce((a, c) => a + c.width, 0);
      },
      rowAccessories() {
        return {
          side_wall_left: (this.data.side_wall === 'wall' ? this.data.side_wall_left : false),
          side_wall_right: (this.data.side_wall === 'wall' ? this.data.side_wall_right : false),
          side_screen: (this.data.side_wall === 'screen'),
          side_screen_count: this.data.side_wall_count,
        };
      },
    },
    methods: {
      setData(data) {
        this.$emit('update', data);
        this.isEdit = false;
      },
      setSide(data) {
        this.$emit('update:side', data);
        this.isEditSide = false;
      },
      addSection(data) {
        this.$emit('addSection', data);
      },
      showCapacity() {
        this.isShowCapacity = true;
      },
      updateCapacity(value) {
        this.$emit('update:capacity', value);
      },
    },
  };
</script>

<style scoped>
  .rowItem {
    margin-bottom: 40px;
  }
  .rowItem-detail {
    margin-right: 30px;
  }
  .rowItem-main {
    display: flex;
    flex-grow: 1;
  }
  .rowItem-head {
    margin-bottom: 23px;
  }
  .rowItem-body {
    display: flex;
    flex-grow: 1;
  }
  .rowItem-sections {
    margin-right: 23px;
  }
  .rowItem-add {

  }
</style>
